use '@use-gpu/wgsl/codec/octahedral'::{ decodeOctahedral, wrapOctahedral };
use '@use-gpu/wgsl/codec/cubemap'::{ encodeCubeMap };

@link var depthTexture: texture_depth_2d_array;
@link var depthSampler: sampler;

@link fn getTextureSize() -> vec2<f32>;
@link fn getShadowDepth() -> vec2<f32>;

@optional @link fn getBorderScale() -> vec2<f32> { return vec2<f32>(1.0); };

@export fn getDepthCubeToOmniSample(uv: vec2<f32>) -> f32 {
  // Map octahedral destination with wrapped border
  let oct = wrapOctahedral((uv.xy * 2.0 - 1.0) * getBorderScale());
  let uvw: vec3<f32> = decodeOctahedral(oct).yzx;

  // Remap to 1px enlarged cubemap
  let xyl = encodeCubeMap(uvw);
  let size = getTextureSize();
  let fovScale = (size - 1.0) / size;

  let uvf = (xyl.xy * fovScale) * .5 + .5;

  // Convert to source texels
  let xyf = uvf * size - .5;
  let xyi = floor(xyf);
  let xyd = xyf - xyi;

  // Map to center of texel quads to avoid textureGather differences
  let xyc = xyi + 1.0;
  let uvc = xyc / size;

  // Bilinear
  let d4 = textureGather(depthTexture, depthSampler, uvc, xyl.layer);

  let sample = mix(
    mix(d4.w, d4.z, xyd.x),
    mix(d4.x, d4.y, xyd.x),
    xyd.y,
  );

  // Remap to radial depth
  let sd = getShadowDepth();
  let maxC = max(abs(uvw.x), max(abs(uvw.y), abs(uvw.z)));
  let depth = mix(sd.x, sample, maxC);

  return depth;
}
